module.exports = __webpack_public_path__ + "frontend/images/homepage/carousel/desktop/3@2.png?c7b9461ea128028ddd0645a81817e2b3";